import React from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-348">
      {label && <label className="block text-sm font-medium mb-1" style={{
      color: 'var(--nmhl-text-primary)'
    }} data-id="element-349">
          {label}
        </label>}
      <input className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent ${error ? 'border-red-500' : 'border-slate-300'} ${className}`} style={{
      '--tw-ring-color': 'var(--nmhl-burgundy)'
    } as React.CSSProperties} {...props} data-id="element-350" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-351">{error}</p>}
    </div>;
}